import React from 'react';

import { Box, Typography } from '@rbilabs/universal-components';

const Container = Box.withConfig({
  flexDirection: 'row',
  justifyContent: 'flex-end',
  alignItems: 'flex-end',
  padding: 0,

  paddingTop: {
    base: '$6',
    md: 0,
  },

  paddingRight: {
    md: 0,
  },

  paddingBottom: {
    md: '$4',
  },

  paddingLeft: {
    md: '$1',
  },
  marginY: {
    base: '$0',
    md: '$2',
  },
});

interface IMoreOptions {
  openFilterModal: () => void;
  buttonText: string;
}
export const MoreOptions: React.FC<React.PropsWithChildren<IMoreOptions>> = ({
  openFilterModal,
  buttonText,
}) => {
  return (
    <Container>
      <Typography
        fontFamily="heading"
        fontSize="sm"
        onPress={openFilterModal}
        accessibilityRole="button"
      >
        {buttonText}
      </Typography>
    </Container>
  );
};
